import firebase from 'firebase'

let firebaseConfig
// if (process.env.NODE_ENV == "" || location.host == "pragma-apps.web.app") {
if (process.env.NODE_ENV == "development" || location.host == "pragma-apps.web.app") {
  firebaseConfig = {
    apiKey: "AIzaSyBVX-jmHFWME5LBeVW1telu6ZmZ9Qo6wE0",
    authDomain: "pragma-apps.firebaseapp.com",
    databaseURL: "https://pragma-apps.firebaseio.com",
    projectId: "pragma-apps",
    storageBucket: "pragma-apps.appspot.com",
    messagingSenderId: "778503155378"
  }
} else {
  firebaseConfig = {
    apiKey: "AIzaSyDOJ3Vi-3Uq52mcFOv6fW0w7MorCuUmpCU",
    authDomain: "pragma-development.firebaseapp.com",
    databaseURL: "https://pragma-development.firebaseio.com",
    projectId: "pragma-development",
    storageBucket: "pragma-development.appspot.com",
    messagingSenderId: "40467882050"
  }
}
console.info(process.env.NODE_ENV)
console.info(location.host)
console.info(firebaseConfig.projectId)
const firebaseApp = firebase.initializeApp(firebaseConfig)


export default firebaseApp